import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import { defaultPostTextSelector } from 'redux/modules/download/selectors';
import { blueskySelector } from 'redux/modules/social';

import { PostStatus } from 'redux/modules/social/constants';

const usernameSelector = createSelector(
  blueskySelector,
  bluesky => bluesky.username,
);

const avatarSrcSelector = createSelector(
  blueskySelector,
  bluesky => bluesky.profileImageUrl,
);

const postStatusSelector = createSelector(
  blueskySelector,
  bluesky => bluesky.postStatus,
);

interface UseBlueskyPostModalConfig {
  defaultDescription?: string;
}

export default function useBlueskyPostModalSelector(
  config: UseBlueskyPostModalConfig = {},
) {
  const { defaultDescription: defaultDescriptionProp } = config;

  const avatarSrc = useSelector(avatarSrcSelector);
  const postStatus: PostStatus = useSelector(postStatusSelector);
  const username = useSelector(usernameSelector);
  const defaultDescription = useSelector(defaultPostTextSelector);

  return {
    avatarSrc,
    postStatus,
    username,
    defaultDescription: defaultDescriptionProp || defaultDescription,
  };
}
